<template>
  <ag-card-container centered :title="$t('menu.profile')">
    <current-user-form
      v-if="user"
      :value="user"
      :loading="loading"
      :submit-label="$t('general.update')"
      :forbidden-user-list="forbiddenUserList"
      disabled-roles
      @input="onInput"
    />
  </ag-card-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AgCardContainer from 'src/components/common/AgCardContainer'
import CurrentUserForm from '../components/CurrentUserForm'

export default {
  name: 'CurrentUserContainer',
  components: {
    AgCardContainer,
    CurrentUserForm,
  },
  data: () => ({
    loading: false,
    forbiddenUserList: [],
  }),
  computed: {
    ...mapGetters('me', {
      user: 'user',
    }),
  },
  methods: {
    ...mapActions('me', {
      updateMe: 'updateMe',
    }),
    async onInput (value) {
      const payload = {
        userLogin: value.userLogin,
        firstName: value.firstName,
        lastName: value.lastName,
        lang: value.lang,
      }

      // Upade password only if changed
      if (value.password) {
        payload.password = value.password
      }

      if (value.email) {
        payload.email = value.email
      }

      this.loading = true
      const { error } = await this.updateMe(payload)

      if (error === 'EditUserLoginTakenError') {
        this.forbiddenUserList.push(payload.userLogin)
      }

      this.loading = false
    },
  },
}
</script>
